<div id="page-manage-resources">
    <div class="page-section">
        <div class="page-section-header">
            <h1 translate>resources.title</h1>
        </div>

        <div class="page-section-content" *ngIf="isLoaded">
            <div *ngIf="role == 'admin'">
                <div class="icon-group select-group">
                    <label for="organization">Select an organization</label>
                    <select class="app-c-form-control" id="organization" [(ngModel)]="organizationIds" multiple>
                        <option value="all">All</option>
                        <option *ngFor="let organizationrow of organizations" [value]="organizationrow.id">
                            {{organizationrow.name}}
                        </option>
                    </select>
                </div>

                <mat-form-field>
                    <input matInput [matDatepicker]="pickerfrom" placeholder="From">
                    <mat-datepicker-toggle matSuffix [for]="pickerfrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerfrom></mat-datepicker>
                </mat-form-field>

                <mat-form-field>
                    <input matInput [matDatepicker]="pickerto" placeholder="To">
                    <mat-datepicker-toggle matSuffix [for]="pickerto"></mat-datepicker-toggle>
                    <mat-datepicker #pickerto></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="app-c-card">
                <div class="app-c-card__content">
                    <h2>{{resourceGroup.resource.title}}</h2>

                    <ul class="app-c-list">
                        <li>Summary: {{resourceGroup.resource.summary}}</li>
                        <li>Summary: None entered</li>
                        <li>
                            Question: {{resourceGroup.questionAnswers.question}}
                        </li>
                        <li>
                            Question: No question entered
                        </li>

                        <li>
                            <div class="strong click-title">Resource clicks</div>
                            <p *ngIf="!resourceGroup.resourceClicks">None</p>
                            <div class="table-responsive" *ngIf="resourceGroup.resourceClicks">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th translate>Url</th>
                                            <th translate>Clicks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let resourceClick of resourceGroup.resourceClicks">
                                            <td>{{resourceClick.url}}</td>
                                            <td>{{resourceClick.count}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>